module.exports = __webpack_public_path__ + "img/ic-info.bf1c219d.svg";